import React from "react";
import RelevesDetailles from "./RelevesDetailles";

const RelevesDetaillesAchat = () => <RelevesDetailles tierLabel="Fournisseur" tiersApi="Suppliers" />;

export default RelevesDetaillesAchat;
